module.exports = __webpack_public_path__ + "static/media/6.52be9d17.svg";